
@switch (button()) {
  <!-- Brugeren har >1 opfølgninger og Andre har opfølgninger -->
  @case (5) {
    <mat-icon
      [matTooltip]="getToolTip('Du og andre ({users}) har flere opfølgninger på denne aftale. Klik for info')"
      class="icon-32"
      svgIcon="bookmark-user-solid"
    ></mat-icon>
    <span class="opfoelgning-bookmark-count opfoelgning-bookmark-count--alt white">{{ useropfolgninger().length }}</span>
  }
  <!-- Brugeren har 1 opfølgning og Andre har opfølgninger -->
  @case (4) {
    <mat-icon
      [matTooltip]="getToolTip('Du og andre ({users}) har opfølgninger på denne aftale. Klik for info')"
      class="icon-32"
      svgIcon="bookmark-user-solid"
    ></mat-icon>
  }
  <!-- Andre har opfølgninger -->
  @case (3) {
    <mat-icon
      [matTooltip]="getToolTip('Mindst en anden bruger ({users}) har lavet en opfølgning på denne aftale. Tilføj personlig opfølgning')"
      class="icon-32"
      svgIcon="bookmark-user-outlined"
    ></mat-icon>
  }
  <!-- Brugeren har >1 opfølgninger -->
  @case (2) {
    <mat-icon
      [matTooltip]="'Du har flere opfølgninger på denne aftale. Klik for info'"
      class="orange icon-32"
      svgIcon="bookmark"
    ></mat-icon>
    <span class="opfoelgning-bookmark-count white">{{ useropfolgninger().length }}</span>
  }
  <!-- Brugeren har 1 opfølgning -->
  @case (1) {
    <mat-icon [matTooltip]="opfoelgninger()" class="orange" svgIcon="bookmark-solid"></mat-icon>
  }
  <!-- Ingen opfølgninger -->
  @default {
    <mat-icon svgIcon="bookmark" class="icon-32" matTooltip="Tilføj personlig opfølgning"></mat-icon>
  }
}
